/* RPS cart drawer glue.
   Dawn's cart-drawer.js only binds #cart-icon-bubble to open the drawer, which
   the custom RPS header does not have. It also never refreshes the drawer after
   a change made on the cart page (CartDrawerItems ignores cartUpdate events
   whose source is 'cart-items', and the cart page publishes exactly that), so
   the drawer is refreshed from the server every time it is opened. */
(function () {
  if (window.__rpsDrawerInit) return;
  window.__rpsDrawerInit = true;

  var SELECTOR = '.rps .nav-links a.cart, .rps a.cart-mobile, [data-rps-open-cart]';

  function drawer() {
    return document.getElementById('RPSCartDrawer');
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function refresh() {
    return fetch(cartUrl() + '?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var src = new DOMParser().parseFromString(text, 'text/html').querySelector('.drawer__inner');
        var dst = document.querySelector('#CartDrawer .drawer__inner');
        if (!src || !dst) return;
        dst.innerHTML = src.innerHTML;
        dst.className = src.className;
      })
      .catch(function () {});
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest(SELECTOR);
      if (!trigger) return;
      var d = drawer();
      if (!d || typeof d.open !== 'function') return;
      event.preventDefault();
      d.open(trigger);
      refresh();
    },
    true
  );

  function sync(count) {
    var d = drawer();
    if (d) d.classList.toggle('is-empty', count === 0);

    var link = document.querySelector('.rps .nav-links a.cart');
    if (link) link.textContent = 'Cart (' + count + ')';

    var bubble = document.querySelector('.rps .cart-mobile__count');
    if (bubble) {
      bubble.textContent = count;
      bubble.classList.toggle('is-empty', count === 0);
    }
  }

  var tries = 0;
  (function hookPubSub() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') {
            sync(event.cartData.item_count);
          } else {
            fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
              .then(function (r) { return r.json(); })
              .then(function (c) { sync(c.item_count); })
              .catch(function () {});
          }
        });
        return;
      }
    } catch (e) {}
    if (tries++ < 60) setTimeout(hookPubSub, 100);
  })();
})();